'use strict';

module.exports = function () {
    $(document).on('click', '.accordion .accordion-heading', function (e) {
        e.preventDefault();
        const $this = $(this);
        if ($this.closest('.accordion-split-module-accordion-tiles').length === 0) {
            const $accordionBtn = $this.find('.accordion-btn-text');
            const $container = $this.closest('.accordion');

            if ($accordionBtn.length) {
                const hideText = $accordionBtn.attr('data-hide-text');
                const showText = $accordionBtn.attr('data-show-text');

                if ($container.hasClass('accordion-hide')) {
                    $accordionBtn.text(hideText);
                } else {
                    $accordionBtn.text(showText);
                }
            }

            $container.toggleClass('accordion-hide');
        }
    });
};
